<img class="app-logo" />
